module.exports = __webpack_public_path__ + "static/media/whodat.6a7b3387.jpeg";